import { render, staticRenderFns } from "./FIBOptionGroup.vue?vue&type=template&id=3b6e7074&scoped=true&"
import script from "./FIBOptionGroup.vue?vue&type=script&lang=js&"
export * from "./FIBOptionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6e7074",
  null
  
)

export default component.exports
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QOptionGroup});
